import { Plus } from "lucide-react";
import { move, uid } from "@/lib/api";
import { ICONS } from "@/components/site/icons";
import { Field, ItemControls, Panel, Toggle } from "./Fields";

export const FeaturesTab = ({ items, onChange }) => {
  const set = (i, patch) => onChange(items.map((f, k) => (k === i ? { ...f, ...patch } : f)));
  const add = () => onChange([...items, { id: uid(), icon: "Star", title: "Novo diferencial", text: "", active: false }]);
  return (
    <Panel
      title="Diferenciais"
      desc="Cadastre apenas serviços confirmados. Somente itens ativos aparecem no site."
      actions={<button type="button" onClick={add} className="inline-flex items-center gap-2 h-10 px-4 text-xs uppercase tracking-[0.15em] bg-white text-black hover:bg-[#E5CF9F]" data-testid="feature-add-button"><Plus className="w-4 h-4" /> Novo diferencial</button>}
    >
      <div className="space-y-4">
        {items.map((f, i) => {
          const Icon = ICONS[f.icon] || ICONS.Star;
          return (
            <div key={f.id} className="border border-white/10 bg-[#08080A] p-5 grid md:grid-cols-[auto_1fr] gap-5" data-testid={`admin-feature-${i}`}>
              <div className="flex md:flex-col items-center gap-3">
                <div className="h-14 w-14 flex items-center justify-center border border-white/10"><Icon className="w-6 h-6 text-[#CBD5E1]" strokeWidth={1.2} /></div>
                <select value={f.icon} onChange={(e) => set(i, { icon: e.target.value })} className="h-9 bg-[#0F0F12] border border-white/10 text-xs text-white px-2" aria-label="Ícone" data-testid={`admin-feature-${i}-icon`}>
                  {Object.keys(ICONS).map((k) => <option key={k} value={k}>{k}</option>)}
                </select>
              </div>
              <div className="space-y-4">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <Toggle label={f.active ? "Ativo (visível)" : "Inativo (oculto)"} checked={f.active} onChange={(v) => set(i, { active: v })} testid={`admin-feature-${i}-active`} />
                  <ItemControls onUp={() => onChange(move(items, i, -1))} onDown={() => onChange(move(items, i, 1))} onDelete={() => onChange(items.filter((_, k) => k !== i))} testid={`admin-feature-${i}`} />
                </div>
                <Field label="Título" value={f.title} onChange={(v) => set(i, { title: v })} testid={`admin-feature-${i}-title`} />
                <Field label="Texto curto" multiline value={f.text} onChange={(v) => set(i, { text: v })} testid={`admin-feature-${i}-text`} />
              </div>
            </div>
          );
        })}
      </div>
    </Panel>
  );
};
